import { purchasedGoodsRoutes } from '@app/purchased-goods/purchased-goods-routes';
import { Button } from '@shared/components/ui/button';
import { generatePath, useNavigate } from 'react-router-dom';
import PackagingPreviewSheet from './packaging-preview-sheet';

export default function CCFPackagingTableToolbar() {
  const navigate = useNavigate();

  return (
    <div className="flex items-center gap-2">
      <Button
        size="sm"
        variant="ghost"
        onClick={() =>
          navigate(
            generatePath(purchasedGoodsRoutes.PURCHASED_GOODS_IMPORTS_LIST) +
              `?activityType=packaging`
          )
        }
      >
        Manage imports
      </Button>
      <PackagingPreviewSheet />
      <Button
        size="sm"
        onClick={() =>
          navigate(generatePath(purchasedGoodsRoutes.PURCHASED_GOODS_IMPORT))
        }
      >
        Add data
      </Button>
    </div>
  );
}
